export type ListSelectMods = { shiftKey?: boolean; metaKey?: boolean; ctrlKey?: boolean }

export function isAdditiveToggleMod(ev: ListSelectMods): boolean {
  return Boolean(ev.metaKey || ev.ctrlKey)
}

export function selectIdRange(orderedIds: readonly string[], fromId: string, toId: string): string[] {
  const a = orderedIds.indexOf(fromId)
  const b = orderedIds.indexOf(toId)
  if (a < 0 || b < 0) return [toId]
  const [lo, hi] = a < b ? [a, b] : [b, a]
  return orderedIds.slice(lo, hi + 1)
}
